// extracted by mini-css-extract-plugin
export default {"modalContent":"DiscordModal-module--modalContent--a45da","close":"DiscordModal-module--close--f1899","joinDiscord":"DiscordModal-module--joinDiscord--5732d"};